<template>
  <div data-app>
    <div class="row mt-1 mx-0 new_list_st_by_ch">
      <div class="row m-0 col-12 p-2 border-r-16">
        <div class="col-md-4 p-0">
          <span class="leatext_job_heading_by_new_home">Latest applicants</span>
        </div>
        <div class="col-md-8 p-0 row m-0" style="align-items: center">
          <a
            href="/recruiter/job-applications"
            class="text-end"
            style="
              font-size: 16px;
              color: rgb(3, 169, 244) !important;
              text-decoration: underline !important;
            "
          >
            view all applications
          </a>
        </div>
      </div>
      <div class="row m-0 col-12 p-0 mt-4" style="height: fit-content">
        <div
          class="col-md-4 row m-0 pt-0 pr-0"
          v-for="(item, index) in data"
          :key="index"
          :class="index == 0 || index % 3 == 0 ? 'pl-0' : ''"
          :style="index == 6 ? 'display:none' : ''"
        >
          <div v-if="!item" class="log text-center">No Data Fount</div>
          <!-- {{item.id}} -->
          <div
            class="col-md-12 row m-0 border-r-16 bg-white"
            v-if="item.job != null"
            :id="
              'jobseeker_app_' +
              item.job_seeker.name
                .toLowerCase()
                .replace(/ /g, '-')
                .replace(/[^\w-]+/g, '') +
              '_' +
              item.job.job_title
                .toLowerCase()
                .replace(/ /g, '-')
                .replace(/[^\w-]+/g, '')
            "
          >
            <div class="col-md-4 p-0" style="position: relative">
              <img
                @error="onImageLoadFailure($event)"
                :src="mediaUrl + item.job_seeker_profile.profile_pic || ''"
                alt="Profile Image"
                id="img_profile"
                style="width: 74px; height: 74px; border-radius: 50%"
              />
              <v-btn
                icon
                :style="item.favorite == 'yes' && 'color: orange'"
                @click="favoriteClick(item.id)"
                class="style_madi_star_n shadow"
              >
                <v-icon>mdi-star</v-icon>
              </v-btn>
            </div>
            <div class="col-md-8 p-0">
              <div
                style="
                  border: 1.5px solid rgb(53, 162, 229);
                  font-size: 12px;
                  padding: 3px 5px;
                  border-radius: 4px;
                  color: rgb(53, 162, 229);
                  width: fit-content;
                  position: absolute;
                  right: 0px;
                  top: 20px;
                  text-align: center;
                  background-color: transparent;
                "
              >
                {{ item.status }}
              </div>
            </div>
            <div class="col-md-12 p-0">
              <span
                class="label label-info"
                style="
                  margin: 13px 0 8px 0;
                  background: #e80000;
                  width: auto !important;
                  padding: 0 8px !important;
                  border-radius: 16px !important;
                  font-size: 14px;
                "
                v-if="
                  item.notification ? item.notification.seen_at == null : ''
                "
                >new</span
              >
            </div>
            <div class="col-md-12 p-0 mt-4">
              <h4
                class="mb-0"
                style="color: #242424; font-size: 18px; font-weight: bold"
              >
                {{ item.job_seeker.name }}
              </h4>
            </div>

            <div class="col-md-12 p-0 py-2">
              <div class="m-0" style="color: #666; font-size: 14px">
                <h4 class="widget-title tooltipch mb-0 bold detail_heading">
                  <img
                    src="/images/job_page/Money_left.svg"
                    alt="..."
                    class="pr-2"
                  /><span class="tooltiptextch">Expected Salary</span>
                </h4>
                {{ item.expected_salary }}
                <span v-if="!item.expected_salary">N/A</span>
              </div>
            </div>

            <div class="col-md-12 p-0">
              <p class="m-0" style="color: #666; font-size: 11px">
                Applied for :<br />
                <b class="text-black" style="font-size: 14px">{{
                  item.job.job_title
                }}</b>
              </p>
            </div>
            <div class="col-md-12 p-0">
              <p class="m-0" style="color: #666; font-size: 11px">
                applied:
                {{ moment(item.job.created_at).format("DD MMM, YY. hh:mmA") }}
              </p>
            </div>
            <hr
              class="col-md-12 p-0 mt-3"
              style="background: rgba(53, 162, 229, 0.25)"
            />
            <div class="_btn_gridddd p-0 m-0">
              <div
                class="p-0"
                @click="
                  view_CV(item.cv_path),
                    notification_read(item.notification.id),
                    (item.notification.seen_at = 'read')
                "
              >
                <button type="button" class="new_details_job_dashbord_list2">
                  <span class="v-btn__content">View CV</span>
                </button>
              </div>
              <div
                class="p-0"
                @click="
                  downloadCV(item.cv_path),
                    notification_read(item.notification.id),
                    (item.notification.seen_at = 'read')
                "
                style=""
              >
                <button type="button" class="new_details_job_dashbord_list2">
                  <span class="v-btn__content">Download CV</span>
                </button>
              </div>
              <div
                class="p-0"
                @click="
                  askUserAboutDelete(item),
                    notification_read(item.notification.id),
                    (item.notification.seen_at = 'read')
                "
              >
                <button
                  type="button"
                  class="new_details_job_dashbord_list2"
                  style="
                    background: rgba(147, 6, 6, 0.05) !important;
                    border-color: rgba(147, 6, 6, 0.5) !important;
                  "
                >
                  <img
                    class="dashbord"
                    src="\images/job_application/Delete.svg"
                    alt=""
                    width="16"
                    height="16"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- ////////////////////////////////// -->
      </div>
    </div>
    <!-- <hr
      class="col-md-12 p-0 mt-5"
      style="background: rgba(53, 162, 229, 0.25)"
    /> -->
    <!-- Confirm Delete Item -->
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-card-title>
            <span class="headline"
              >Do you really want to DELETE this item?</span
            >
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="custom-submit-button" text @click="dialog = false"
              >No</v-btn
            >
            <v-btn class="custom-cancel-button" text @click="deleteItem"
              ><b-spinner small type="grow" v-if="deleting"></b-spinner
              >Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
import Swal from "sweetalert2";
import RecruiterService from "@/MainServices/RecruiterService.js";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import { VueEditor } from "vue2-editor";
import moment from "moment";

export default {
  data() {
    return {
      mediaUrl: MEDIA_URL,
      profile: JSON.parse(localStorage.getItem("profile")),
      statusItems: [
        "All",
        "Applied",
        "Shorlisted",
        "Call For Interview",
        "interviewed",
        "Selected",
      ],
      filter: "",
      search: "",
      stutas_val: "",
      loading: true,
      dialog: false,
      deleteId: null,
      deleting: false,
      success: false,
      token: `Bearer ${localStorage.getItem("token")}`,
      valid: true,
      user: JSON.parse(localStorage.getItem("user")),
      data: [],
      originalData: [],
      message: "",
      file: null,
      file_url: null,
      jobId: null,
      data_Filter: [],
    };
  },

  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    this.getInititalData();
  },
  components: {
    videoPlayer,
    VueEditor,
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  methods: {
    moment: function (item) {
      return moment(item);
    },
    onImageLoadFailure(event) {
      event.target.src = "../images/profile_ch.jpg";
    },
    getInititalData() {
      RecruiterService.getJobApplications()
        .then((res) => {
          this.loading = false;
          var temp = [];
          // .job.job_title
          // console.log(window.location.search.replace('?',''));
          if (window.location.search) {
            this.data_Filter = res.data.filter(
              (item) => item.job_id == window.location.search.replace("?", "")
            );
          } else {
            this.data_Filter = res.data;
          }
          this.data_Filter.forEach((element) => {
            // this.job_jobsekeer.push(element.job_seeker.name);
            element.videoPlayer = {
              // videojs options
              muted: true,
              language: "en",
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              sources: [
                {
                  type: "video/mp4",
                  src: this.mediaUrl + "videos/raw/" + element.intro_video,
                },
              ],
              poster: "/static/images/author.jpg",
            };
            element.videoPlayer1 = {
              // videojs options
              muted: true,
              language: "en",
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              sources: [
                {
                  type: "audio/wav",
                  src: this.mediaUrl + "videos/raw/" + element.intro_audio,
                },
              ],
              poster: "/static/images/author.jpg",
            };
            var msgs_counts = 0;

            element.job.threads.map((el) => {
              el.msgs.map((e) => {
                if (
                  e.seen_at == null &&
                  e.receiver_id === this.profile.user_id
                ) {
                  msgs_counts++;
                }
              });
            });
            element.msgs_counts = msgs_counts;
            temp.push(element);
          });
          this.data = temp;
          this.originalData = temp;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    favoriteClick(id) {
      RecruiterService.changeJobApplicationFavoriteStatus(id)
        .then((res) => {
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    filterData() {
      var temp = [];
      var val = this.filter;
      if (val == "All") {
        this.data = this.originalData;
      } else {
        this.originalData.forEach((element) => {
          if (element.status == val) {
            temp.push(element);
          }
        });
        this.data = temp;
      }
    },
    downloadCV(path) {
      if (path) {
        window.open(this.mediaUrl + path);
      } else {
        Swal.fire({
          title: "",
          text: "No CV is available. Please send message to job seeker asking for  CV.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      }
      // window.open(this.mediaUrl + path);
    },
    view_CV(path) {
      if (path) {
        //docs.google.com/gview?url=https://api.job4u.pk/public/storage/cvs/2L4ZDNuKi22C8UnqzjGIbavJEGhw8k961J5qeQ0g.pdf&embedded=true
        https: window.open(
          "https://docs.google.com/gview?url=" +
            this.mediaUrl +
            path +
            "&embedded=true",
          "_blank"
        );
      } else {
        Swal.fire({
          title: "",
          text: "No CV is available. Please Add your CV.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      }
    },
    deleteApplication(id) {
      RecruiterService.deleteJobApplication(id)
        .then((res) => {
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.dialog = false;
          this.loading = false;
          this.success = true;
          this.submitting = false;
          this.getInititalData();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },

    deleteItem() {
      this.deleteApplication(this.deleteId);
    },

    Preview_image() {
      this.file_url = this.file;
    },
  },
};
</script>
